<script lang="ts">
  import Button from '$lib/components/ui/button/button.svelte';
  import Input from '$lib/components/ui/input/input.svelte';
  import Label from '$lib/components/ui/label/label.svelte';
  import { toast } from 'svelte-sonner';

  let {
    fields = $bindable([]),
    draft = $bindable<Record<string, unknown>>({}),
    experience,
    accountLoading = false,
  } = $props();

  let loading = $state(false);

  function handleSubmit(e: any) {
    e?.preventDefault?.();
    if (!fields?.length) return;

    const fieldsPayload = Object.fromEntries(
      fields
        .filter((f) => f?.id !== 'password')
        .map((f) => [String(f.id), draft?.[f.id]]),
    );

    const payload = { ...draft, ...fieldsPayload };

    // Emit accountUpdate event with type 'userData'
    if (experience?.eventHub) {
      loading = true;
      toast.info('Updating Account Details...');
      experience.eventHub.emit('accountUpdate', {
        type: 'userData',
        data: payload,
      });
    } else {
      toast.error('Unable to update account - event system not available');
    }
  }

  // Listen for accountUpdate response to update loading state
  $effect(() => {
    if (experience?.eventHub) {
      const handleUpdateComplete = (success: boolean) => {
        loading = false;
        if (success) {
          toast.success('Account Details updated!');
        } else {
          toast.error('There was an error while updating Account Details');
        }
      };

      experience.eventHub.on('accountUpdate:userData:complete', handleUpdateComplete);

      return () => {
        experience.eventHub.off('accountUpdate:userData:complete', handleUpdateComplete);
      };
    }
  });
</script>

<div class="flex !flex-col !px-4 w-full">
  {#if accountLoading}
    <p class="text-sm text-muted-foreground mb-3">Loading account…</p>
  {/if}
  <div class="w-full">
    <form class="grid grid-cols-2 gap-4 pb-2" onsubmit={(e) => handleSubmit(e)}>
      {#each fields as f (f.id)}
        {#if f?.id !== 'password'}
          <div class="flex !flex-col !items-start !justify-start gap-1">
            <Label for={f.label} class="text-left text-xs font-normal">
              {f.label}
            </Label>

            <Input
              id={f.label}
              bind:value={draft[f.id]}
              disabled={accountLoading}
              class="col-span-3 !w-full !px-4 !py-5 text-xs !outline-none
    focus:!outline-none
    focus-visible:!outline-none
    
    focus:ring-0
    focus-visible:ring-0
    !ring-0
    !shadow-none
    focus:!shadow-none
    focus-visible:!shadow-none"
              placeholder={f.description || f.label}
            />
          </div>
        {/if}
      {/each}
    </form>
  </div>
  <div class="flex justify-end gap-2 !mt-4 shrink-0 w-full">
    <Button
      type="submit"
      onclick={(e) => handleSubmit(e)}
      disabled={loading || accountLoading}
      class={` h-9 !px-4 !py-6 border-none !shadow-none  !text-sm font-normal hover:brightness-110 transition text-white !bg-[#004976] dark:!bg-[var(--theme-link)]`}>Save changes</Button
    >
  </div>
</div>
